var map = {
	"./about.svg": "a85b",
	"./account-safety.svg": "50ca",
	"./add-friend-active.svg": "f957",
	"./add-friend-normal.svg": "2c5d",
	"./add-friend.svg": "6a12",
	"./appoint-scs.svg": "1fc1",
	"./arrow-left.svg": "12e3",
	"./arrow-right-active.svg": "7645",
	"./arrow-right.svg": "6929",
	"./arrow.svg": "b6e4",
	"./bell.svg": "2fa4",
	"./calendar-active.svg": "592c",
	"./calendar-default.svg": "be39",
	"./calendar.svg": "0870",
	"./close-filled-disabled.svg": "22b2",
	"./close-filled-enabled.svg": "e226",
	"./close.svg": "7710",
	"./coc-empty.svg": "e302",
	"./coc-metting.svg": "6eb3",
	"./conference-accept.svg": "2819",
	"./conference-reject.svg": "0038",
	"./copy.svg": "19b6",
	"./corp.svg": "eba6",
	"./date-picker-default.svg": "0de7",
	"./device-computer.svg": "f511",
	"./device-connect.svg": "576e",
	"./device-glasses.svg": "1c3f",
	"./device-phone.svg": "e23d",
	"./device-web.svg": "d777",
	"./download.svg": "4dae",
	"./draw-clear.svg": "fd07",
	"./draw-close.svg": "7e6a",
	"./draw-save.svg": "2c21",
	"./draw-sticker.svg": "f593",
	"./draw-undo.svg": "2a5d",
	"./drawn-line-color.svg": "596e",
	"./drawn-line-width.svg": "90f1",
	"./edit-active.svg": "70ae",
	"./edit.svg": "aa46",
	"./empty.svg": "c091",
	"./exit.svg": "5dbb",
	"./fly-elephant.svg": "5064",
	"./im.svg": "db67",
	"./invite.svg": "e037",
	"./invitemore.svg": "efa7",
	"./login-logo.svg": "5df9",
	"./logo-about.svg": "6e39",
	"./logo.svg": "bb69",
	"./metting.svg": "64c6",
	"./no-person.svg": "0344",
	"./org.svg": "2edd",
	"./profile.svg": "f93a",
	"./quarter-round.svg": "f86c",
	"./remind.svg": "18ef",
	"./search.svg": "8e8d",
	"./setting.svg": "05ff",
	"./share.svg": "5306",
	"./signal-best.svg": "67b2",
	"./signal-better.svg": "4718",
	"./signal-good.svg": "56c1",
	"./signal-not.svg": "2b1c",
	"./signal-poor.svg": "2e0a",
	"./slam-mark.svg": "a4a6",
	"./switch-off.svg": "ecd0",
	"./switch-on.svg": "e75e",
	"./talking-camera-off.svg": "3a16",
	"./talking-camera-on.svg": "e40d",
	"./talking-device-glass.svg": "2e52",
	"./talking-file.svg": "3507",
	"./talking-freeze-off.svg": "1687",
	"./talking-freeze-on.svg": "abab",
	"./talking-hangup.svg": "9050",
	"./talking-mark-role.svg": "4ffd",
	"./talking-member-camera.svg": "12cb2",
	"./talking-member-microphone-off.svg": "f066",
	"./talking-member-microphone-on.svg": "5c84",
	"./talking-member.svg": "b063",
	"./talking-microphone-off.svg": "b7bd",
	"./talking-microphone-on.svg": "ada5",
	"./talking-realtime-mark-off.svg": "9249",
	"./talking-realtime-mark-on.svg": "afe6",
	"./talking-screen-sharing.svg": "315a",
	"./talking-slam-mark-off.svg": "9988",
	"./talking-slam-mark-on.svg": "50b4",
	"./talking-speaker-off.svg": "c21d",
	"./talking-speaker-on.svg": "23a1",
	"./talking-whiteboard-off.svg": "67d6",
	"./talking-whiteboard-on.svg": "141c",
	"./upload-full.svg": "fd16",
	"./upload.svg": "9d82",
	"./video-off.svg": "023f",
	"./video.svg": "8f2b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "51ff";